import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import AuthService from "../../services/AuthService";
import {
  getHomeRoute,
  getUserTypes,
  hasUserType,
  resolveActiveUserType,
  USER_TYPES,
} from "../../auth/userTypeUtils";
import Spinner from "../spin/Spin";

const RequireUserType = ({ allowed = [], children }) => {
  const [ready, setReady] = useState(false);
  const [allowedAccess, setAllowedAccess] = useState(false);
  const [fallbackRoute, setFallbackRoute] = useState(getHomeRoute(USER_TYPES.DAM));

  useEffect(() => {
    let cancelled = false;

    Promise.all([AuthService.getUser(), AuthService.getActiveUserType()]).then(
      ([user, activeType]) => {
        if (cancelled) return;

        const hasAllowedType = allowed.some((type) => hasUserType(user, type));
        const types = getUserTypes(user);
        const activeUserType =
          resolveActiveUserType(user, activeType) ?? USER_TYPES.DAM;

        const matchesActiveOrg =
          types.length <= 1 || allowed.includes(activeUserType);

        setAllowedAccess(hasAllowedType && matchesActiveOrg);
        setFallbackRoute(getHomeRoute(activeUserType));
        setReady(true);
      }
    );

    return () => {
      cancelled = true;
    };
  }, [allowed]);

  if (!ready) return <Spinner />;

  if (!allowedAccess) {
    return <Navigate to={fallbackRoute} replace />;
  }

  return children;
};

export default RequireUserType;
